export default {
  metadata: {
    title: 'The latest insurance insights and analysis from the Artificial team. - artificial',
    desc: 'Blog posts, insights and news on all things insurance from the team at Artificial.',
  },
}
